<template>
    <div class="love-map-pdf" data-product-screenshot>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "TxRendererScreenshotArea"
    }
</script>

<style scoped>
    .love-map-pdf {
        position: relative;
        z-index: 99999999999;
        height: 100%;
        width: 100%;
    }
</style>